import { createStyles, Theme } from '@material-ui/core/styles'

export default (theme: Theme) =>
	createStyles({
		container: {
			width: '100%',
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'flex-start',
			alignSelf: 'stretch',
			position: 'absolute',
			flexGrow: 1,
			height: '100%',
			[theme.breakpoints.down('sm')]: {
				padding: `0px ${theme.spacing(1)}px`,
			},
			'& > div:first-child': {
				flexGrow: 1,
				overflowY: 'auto',
				marginLeft: theme.spacing(-7),
				paddingLeft: theme.spacing(7),
			},
			'& > div': {
				alignSelf: 'stretch',
			},
		},
		titleEditor: {
			marginTop: theme.spacing(2),
			'& input': {
				color: theme.palette.grey[800],
				fontSize: 16,
				fontFamily: 'Open Sans, sans-serif',
				"&::placeholder": {
					fontSize: '16px !important',
					color: theme.palette.grey[300],
					opacity: '1 !important',
					fontWeight: 500,
				},
			},
		},
		p: {},
		teaserContainer: {
			marginTop: 'auto',
			marginBottom: 0,
			height: theme.spacing(7),
			minHeight: theme.spacing(7),
			display: 'flex',
			flexDirection: 'column',
			alignItems: 'center',
			justifyContent: 'center',
			borderTop: `1px solid ${theme.palette.grey[200]}`,
		},
		teaserInput: {
			'& input': {
				color: theme.palette.grey[800],
				fontSize: 16,
				fontFamily: 'Open Sans, sans-serif',
				"&::placeholder": {
					fontSize: '16px !important',
					color: theme.palette.grey[300],
					opacity: '1 !important',
					fontWeight: 500,
				},
			},
		},
		textError: {
			'& input::-webkit-input-placeholder': {
				/* Chrome/Opera/Safari */
				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
			'& input::-moz-placeholder': {
				/* Firefox 19+ */

				color: '#FC2652!important',
				fontWeight: 'bold',
				opacity: '1',
			},
			'& input:-moz-placeholder': {
				/* Firefox 18- */
				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
			'& input:-ms-input-placeholder': {
				/* IE 10+ */
				color: '#FC2652 !important',
				fontWeight: 'bold',
				opacity: '1',
			},
		},
	})
